import { updateProfile, profile, gestation, historic, risk, updateGestation, updateHistoric, updateRisk, getMyProfile, updateWeight } from '@/services/pregnancyData.service';


export default {
	namespaced: true,
	state: {
		// STATUS
		aboutStatus: 'init',
        gestationStatus: 'init',
        historicStatus: 'init',
        riskStatus: 'init',
        weightStatus: 'init',
	},
	getters: {
		// STATUS
		getAboutStatus(state){
			return state.aboutStatus
		},
        getGestationStatus(state){
			return state.gestationStatus
		},
        getHistoricStatus(state){
			return state.historicStatus
		},
        getRiskStatus(state){
			return state.riskStatus
		},
		getWeightStatus(state){
			return state.weightStatus
		},

	},
	mutations: {
		// STATUS
		ABOUT_STATUS(state, value) {
			state.aboutStatus = value;
		},
        GESTATION_STATUS(state, value) {
			state.aboutStatus = value;
		},
        HISTORIC_STATUS(state, value) {
			state.aboutStatus = value;
		},
        RISCK_STATUS(state, value) {
			state.aboutStatus = value;
		},
        WEIGHT_STATUS(state, value) {
			state.aboutStatus = value;
		},
	},
	actions: {
		async createAbout({ commit }, params) {
			commit('ABOUT_STATUS', 'pending');
			try {
				const { data } = await profile(params)
				commit('ABOUT_STATUS', 'init');
				return data;
			} catch (error) {
				commit('ABOUT_STATUS', 'init');
				throw error
			}
		},
		async updateAbout({ commit }, params) {
			commit('ABOUT_STATUS', 'pending');
			try {
				const { data } = await updateProfile(params)
				commit('ABOUT_STATUS', 'init');
				return data;
			} catch (error) {
				commit('ABOUT_STATUS', 'init');
				throw error
			}
		},
		async getProfile({ commit }, params) {
			commit('ABOUT_STATUS', 'pending');
			try {
				const { data } = await getMyProfile()
				commit('ABOUT_STATUS', 'init');
				return data;
			} catch (error) {
				commit('ABOUT_STATUS', 'init');
				throw error
			}
		},
        async createPregnancy({ commit }, params) {
			commit('GESTATION_STATUS', 'pending');
			try {
				const { data } = await gestation(params)
				commit('GESTATION_STATUS', 'init');
				return data;
			} catch (error) {
				commit('GESTATION_STATUS', 'init');
				throw error
			}
		},
        async updatePregnancy({ commit }, params) {
			commit('GESTATION_STATUS', 'pending');
			try {
				const { data } = await updateGestation(params)
				commit('GESTATION_STATUS', 'init');
				return data;
			} catch (error) {
				commit('GESTATION_STATUS', 'init');
				throw error
			}
		},
        async createHistoric({ commit }, params) {
			commit('HISTORIC_STATUS', 'pending');
			try {
				const { data } = await historic(params)
				commit('HISTORIC_STATUS', 'init');
				return data;
			} catch (error) {
				commit('HISTORIC_STATUS', 'init');
				throw error
			}
		},
        async updateHistoric({ commit }, params) {
			commit('HISTORIC_STATUS', 'pending');
			try {
				const { data } = await updateHistoric(params)
				commit('HISTORIC_STATUS', 'init');
				return data;
			} catch (error) {
				commit('HISTORIC_STATUS', 'init');
				throw error
			}
		},
        async createRisk({ commit }, params) {
			commit('RISCK_STATUS', 'pending');
			try {
				const { data } = await risk(params)
				commit('RISCK_STATUS', 'init');
				return data;
			} catch (error) {
				commit('RISCK_STATUS', 'init');
				throw error
			}
		},
        async updateRisk({ commit }, params) {
			commit('RISCK_STATUS', 'pending');
			try {
				const { data } = await updateRisk(params)
				commit('RISCK_STATUS', 'init');
				return data;
			} catch (error) {
				commit('RISCK_STATUS', 'init');
				throw error
			}
		},
		async putWeight({ commit }, params) {
			commit('WEIGHT_STATUS', 'pending');
			try {
				const { data } = await updateWeight(params)
				commit('WEIGHT_STATUS', 'init');
				return data;
			} catch (error) {
				commit('WEIGHT_STATUS', 'init');
				throw error
			}
		},

	},
}
